import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _MEDIA_ACTIONS_VS_DEV, _CASTING_APP_TYPE_VS_, _CUSTOMER_TYPES, _DMV_TYPES_LABEL, _LEASE_WORKING_CASH_P;

import { getCurrencySymbol } from '../../formatters/formatCurrency';
export var TAGS = {
  FEE_UPDATE: 'FEE_UPDATE',
  MORE_FIELD_SECTIONN_INFO_COLUMN: 'MORE_FIELD_SECTIONN_INFO_COLUMN',
  MORE_FIELD_SECTIONN_TITLE_COLUMN: 'MORE_FIELD_SECTIONN_TITLE_COLUMN'
};
export var LEASE_WORKING_CASH = {
  USE_TRADE_IN_FOR_CCR: 'USE_TRADE_IN_FOR_CCR',
  USE_REBATES_IN_FOR_CCR: 'USE_REBATES_IN_FOR_CCR',
  CONFIG_TYPE: 'leaseWorkingCashConfigs',
  IDENTIFIER_KEY: 'leaseWorkingCashType',
  USE_DOWNPAYMENT_FOR_CCR: 'USE_DOWNPAYMENT_FOR_CCR',
  CASH_ALWAYS_COVERS_DRIVEOFF: 'CASH_ALWAYS_COVERS_DRIVEOFF',
  AUTO_ROLL_CASH_DEFICIENCY: 'AUTO_ROLL_CASH_DEFICIENCY'
};
export var LEASE_WORKING_CASH_ORDER = [LEASE_WORKING_CASH.USE_TRADE_IN_FOR_CCR, LEASE_WORKING_CASH.USE_REBATES_IN_FOR_CCR, LEASE_WORKING_CASH.USE_DOWNPAYMENT_FOR_CCR, LEASE_WORKING_CASH.CASH_ALWAYS_COVERS_DRIVEOFF, LEASE_WORKING_CASH.AUTO_ROLL_CASH_DEFICIENCY];
export var NEGATIVE_TRADE_PAYOFFS = {
  EXCESS_DOWNPAYMENT: 'EXCESS_DOWNPAYMENT',
  EXCESS_REBATES: 'EXCESS_REBATES',
  CONFIG_TYPE: 'negativeTradePayOffs',
  IDENTIFIER_KEY: 'payOfftype'
};
export var NOTES_ASSET_TYPE = {
  CONTRACTS: 'CONTRACT'
};
export var DEPARTMENTS = {
  SALES: 'SALES'
};
export var DSE_CONTACT_TYPES = {
  MOBILE: 0,
  HOME: 1,
  WORK: 2
};
export var ASCENDING = 'ASC';
export var DESCENDING = 'DESC';
export var actionHandlers = {
  ADD_NEW_ADDRESS: 'ADD_NEW_ADDRESS',
  ZIP_CODE_REFRESH: 'ZIP_CODE_REFRESH',
  ZIP_CODE_RESOLVED: 'ZIP_CODE_RESOLVED',
  SELECT_MAP_LOCATION: 'SELECT_MAP_LOCATION',
  ADDRESS_RESOLVED: 'ADDRESS_RESOLVED',
  INSURANCE_COMPANY_ADDRESS_RESOLVED: 'INSURANCE_COMPANY_ADDRESS_RESOLVED',
  ON_VIN_DETAILS_FETCH: 'ON_VIN_DETAILS_FETCH'
};
export var PAPER_SIZE = {
  LETTER: 'Letter',
  A4: 'A4'
};
export var INDIVIDUAL = 0;
export var BUSINESS = 1;
export var VEHICLE_TYPE = {
  NEW: 'NEW',
  USED: 'USED',
  LOANER: 'LOANER',
  RENTAL: 'RENTAL',
  COMPANY: 'COMPANY',
  SPECIAL: 'SPECIAL'
};
export var TRADE_IN_ACV_RANGE = 'TRADE_IN_ACV_RANGE';
export var SELLING_PRICE_RANGE = 'SELLING_PRICE_RANGE';
export var INVOICE_PRICE_RANGE = 'INVOICE_PRICE_RANGE';
export var PAYMENT_TYPE = 'PAYMENT_TYPE';
export var STOCK_TYPE = 'STOCK_TYPE';
export var DEAL_TYPE = 'DEAL_TYPE';
export var F_N_I_PRODUCT_SELLING_PRICE_RANGE = 'F_N_I_PRODUCT_SELLING_PRICE_RANGE';
export var DUE_BILL_SELLING_PRICE_RANGE = 'DUE_BILL_SELLING_PRICE_RANGE';
export var F_N_I_PRODUCT_COST_PRICE_RANGE = 'F_N_I_PRODUCT_COST_RANGE';
export var DUE_BILL_COST_PRICE_RANGE = 'DUE_BILL_COST_RANGE';
export var MAKES = 'MAKE';
export var MODELS = 'MODEL';
export var TRIMS = 'TRIM';
export var TRADE_INS = 'TRADE_INS';
export var IN_STATE = 'IN_STATE';
export var OUT_STATE = 'OUT_STATE';
export var BODY_CLASS = 'BODY_CLASS';
export var RETAIL = 'RETAIL_PRICE';
export var MSRP = 'MSRP';
export var DEFAULT_NEW_SELLING_PRICE = 'priceType';
export var TRADE_IN_OWNERSIP_TYPE = 'TRADEIN_OWNERSHIP_TYPE';
export var STATES = 'STATE';
export var LENDERS = 'LENDER';
export var SYSTEM = 'System';
export var VEHICLE_STATUS = 'CERTIFIED_VECHICLE';
export var VEHICLE_CERTIFIED = 'VEHICLE_CERTIFIED';
export var OEM_CERTIFIED = 'OEM_CERTIFIED_VEHICLE';
export var DEALER_CERTIFIED = 'DEALER_CERTIFIED_VEHICLE';
export var LICENSE_EXPIRATION_DATE_IN_DAYS = 'LICENSE_EXPIRATION_DATE_IN_DAYS';
export var MODEL_YEAR = 'MODEL_YEAR';
export var AGE = 'AGE';
export var FUEL_TYPE = 'FUEL_TYPE';
export var TRADE_IN_MILEAGE_RANGE = 'TRADE_IN_MILEAGE_RANGE';
export var TRADE_IN_YEAR = 'TRADE_IN_YEAR';
export var SITE = 'SITE_SOLD';
export var STOCK_SUB_TYPE = 'STOCK_SUB_TYPE';
export var SOLD_VEHICLE_SUB_TYPE = 'SOLD_VEHICLE_SUB_TYPE';
export var TRADE_IN_SUB_TYPE = 'TRADE_IN_SUB_TYPE';
export var COLLECT_ONLY_WHEN_COLLECTFEE_IS_ON = 'COLLECT_ONLY_WHEN_COLLECTFEE_IS_ON';
export var INTERNET_PRICE = 'INTERNET_PRICE';
export var VEHICLE_MILEAGE = 'VEHICLE_MILEAGE';
export var MODEL_YEAR_DIFFERENCE_LESSER_THAN = 'MODEL_YEAR_DIFFERENCE_LESSER_THAN';
export var ATTRIBUTE_TYPES = {
  PAYMENT_TYPE: 'PAYMENT_TYPE',
  SELLING_PRICE_RANGE: 'PAYMENT_TYPE',
  STOCK_TYPE: 'PAYMENT_TYPE'
};
export var INCLUDE_OPERATOR = 'INCLUDE';
export var EXCLUDE_OPERATOR = 'EXCLUDE';
export var SECOND_TAX_RATE = 'secondTaxRate';
export var DOWNPAYMENTS = 'downPayments';
export var RO_STATUS = {
  CLOSED: 'CLOSED'
};
export var DEFICIT_BEARER_TYPE = {
  CUSTOMER: 0,
  DEALER: 1
};
export var EQUAL_SPLIT = 'EQUAL_SPLIT';
export var ONLY_FOR_PRIMARY_SALESPERSON = 'ONLY_FOR_PRIMARY_SALESPERSON';
export var ONLY_FOR_PRIMARY_ASSIGNEE = 'ONLY_FOR_PRIMARY_ASSIGNEE';
export var DMV_TYPES = {
  DMV_DESK: 'DMV_DESK',
  DLR_DMV: 'DLR_DMV',
  MARVIN_MISSISSIPPI: 'MARVIN_MISSISSIPPI',
  CVR: 'CVR'
};
export var VEHICLE_SOURCE = {
  ROLLBACK: 'ROLLBACK',
  DEALER_TRADE: 'DEALER_TRADE',
  OEM: 'OEM',
  TRADE_IN_ONE: 'TRADE_IN_ONE',
  TRADE_IN_TWO: 'TRADE_IN_TWO',
  AUCTION_OR_WHOLESALE: 'AUCTION_OR_WHOLESALE'
};
export var TRADE_IN_VALUE = 'TRADE_IN_';
export var TRADE_IN_MIN_VALUE = 2;
export var TRADE_IN_MAX_VALUE = 5;
export var MEDIA_ACTIONS = {
  PRINT: 'PRINT',
  DOWNLOAD: 'DOWNLOAD',
  CASTING: 'CASTING',
  CONCIERGE_SHARE: 'CONCIERGE_SHARE',
  EMAIL: 'EMAIL'
};
export var CASTING_DEVICES = {
  IPAD: 'IPAD',
  CONCIERGE: 'CONCIERGE'
};
export var MEDIA_ACTIONS_VS_DEVICE_TYPES = (_MEDIA_ACTIONS_VS_DEV = {}, _defineProperty(_MEDIA_ACTIONS_VS_DEV, MEDIA_ACTIONS.CASTING, CASTING_DEVICES.IPAD), _defineProperty(_MEDIA_ACTIONS_VS_DEV, MEDIA_ACTIONS.CONCIERGE_SHARE, CASTING_DEVICES.CONCIERGE), _MEDIA_ACTIONS_VS_DEV);
export var TERM_OF_INSURANCES = [[1, 12], [13, 24], [25, 36], [37, 48], [49, 60], [61, 72], [73, 84]];
export var FNI_PDF_VIEW_TYPE = {
  COMPACT: 'COMPACT',
  COMFORTABLE: 'COMFORTABLE',
  STANDARD: 'STANDARD'
};
export var IMG_EXTENSIONS = {
  PNG: 'png',
  JPEG: 'jpeg',
  JPG: 'jpg'
};
export var VIDEO_EXTENSIONS = {
  MP4: 'mp4',
  MOV: 'mov',
  FLV: 'flv',
  AVI: 'avi',
  WMV: 'wmv'
};
export var PRICE_PROPS = {
  addonBefore: getCurrencySymbol(),
  type: 'number'
};
export var DEFAULT_DEALER_MONTH_CONFIG = {
  startDay: 1
};
export var VIN_LOOKUP = {
  SUCCESS: 'SUCCESS',
  PARTIAL: 'PARTIAL'
};
export var PERMISSION_BASED_VEHILE_COLUMNS = ['DEAL_VI_glBalance', 'DEAL_VI_profit', 'DEAL_VI_invoicePrice'];
export var VEHICLE_PRICING_KEYS = {
  MSRP: 'msrp',
  RETAIL_PRICE: 'retailPrice',
  INVOICE_PRICE: 'invoicePrice',
  EMPLOYEE_PRICE: 'employeePrice',
  SUPPLIER_PRICE: 'supplierPrice',
  WHOLESALE_PRICE: 'wholesalePrice',
  INTERNET_PRICE: 'internetPrice',
  LIST_PRICE: 'listPrice',
  COMMISSION_PRICE: 'commissionPrice'
};
export var CALCULATION_PARAMETERS = {
  FLAT_AMT: 'FLAT_AMT',
  SELLING_PRICE_PCT: 'SELLING_PRICE_PCT'
};
export var AUTO_ROLL_DEFICIT_BEARER = {
  DEALERSHIP: 'DEALERSHIP',
  CUSTOMER: 'CUSTOMER'
};
export var CASTING_APP_TYPE = {
  IPAD: 'IPAD',
  DRS: 'DRS',
  WEB: 'WEB'
};
export var CASTING_APP_TYPE_VS_API_ENDPOINT = (_CASTING_APP_TYPE_VS_ = {}, _defineProperty(_CASTING_APP_TYPE_VS_, CASTING_APP_TYPE.IPAD, 'ipad'), _defineProperty(_CASTING_APP_TYPE_VS_, CASTING_APP_TYPE.DRS, 'DRS'), _CASTING_APP_TYPE_VS_);
export var DEMO_MILEAGE_ADJUSTMENT_TYPES = {
  CHECKBOX: 'CHECKBOX',
  RADIO_BUTTON: 'RADIOBUTTON'
};
export var CUSTOMER_TYPES = (_CUSTOMER_TYPES = {}, _defineProperty(_CUSTOMER_TYPES, INDIVIDUAL, __('Individual')), _defineProperty(_CUSTOMER_TYPES, BUSINESS, __('Business')), _CUSTOMER_TYPES);
export var DMV_TYPES_LABEL = (_DMV_TYPES_LABEL = {}, _defineProperty(_DMV_TYPES_LABEL, DMV_TYPES.DMV_DESK, __('DMV Desk')), _defineProperty(_DMV_TYPES_LABEL, DMV_TYPES.DLR_DMV, __('DLR DMV')), _defineProperty(_DMV_TYPES_LABEL, DMV_TYPES.MARVIN_MISSISSIPPI, __('Marvin')), _defineProperty(_DMV_TYPES_LABEL, DMV_TYPES.CVR, __('CVR')), _DMV_TYPES_LABEL);
export var LEASE_WORKING_CASH_DISPLAY_NAMES = {
  USE_TRADE_IN_FOR_CCR: __('Use Trade-In only for CCR'),
  USE_REBATES_IN_FOR_CCR: __('Use Rebates only for CCR'),
  USE_DOWNPAYMENT_FOR_CCR: __('Use Customer Cash only for CCR'),
  AUTO_ROLL_CASH_DEFICIENCY: __('Auto Roll on Cash Deficiency'),
  CASH_ALWAYS_COVERS_DRIVEOFF: __('Drive-Off is always collected')
};
export var USER_PREFERENCE_SETTINGS_DISPLAY_NAMES = {
  AUTO_ROLL_ON_CASH_DEF: __('Auto Roll on Cash Deficiency')
};
export var NEGATIVE_TRADE_PAYOFFS_DISPLAY_NAMES = {
  EXCESS_DOWNPAYMENT: __('Customer Cash'),
  EXCESS_REBATES: __('Excess Rebates')
};
export var CASTING_MESSAGE = {
  IPAD: 'iPad casting in process',
  DRS: 'F&I Sharing Now'
};
export var DEFAULT_STOCK_ID = 'LOCATE';
export var LEASE_WORKING_CASH_PRESET = {
  NONE: 'NONE',
  TOTAL_OUT_OF_POCKET: 'TOTAL_OUT_OF_POCKET_CASH',
  SIGN_AND_DRIVE: 'SIGN_AND_DRIVE',
  DOWN_PAYMENT_WITH_DRIVE_OFF: 'DOWNPAYMENT_WITH_INCEPTIONFEE',
  DOWN_PAYMENT_WITH_MAX_DRIVE_OFF: 'DOWNPAYMENT_WITH_MAX_INCEPTIONFEE',
  DOWN_PAYMENT_WITH_MIN_DRIVE_OFF: 'DOWNPAYMENT_WITH_MIN_INCEPTIONFEE'
};
export var LEASE_WORKING_CASH_PRESET_LABELS = (_LEASE_WORKING_CASH_P = {}, _defineProperty(_LEASE_WORKING_CASH_P, LEASE_WORKING_CASH_PRESET.NONE, 'None'), _defineProperty(_LEASE_WORKING_CASH_P, LEASE_WORKING_CASH_PRESET.TOTAL_OUT_OF_POCKET, __('Total Out of Pocket')), _defineProperty(_LEASE_WORKING_CASH_P, LEASE_WORKING_CASH_PRESET.SIGN_AND_DRIVE, __('Sign and Drive')), _defineProperty(_LEASE_WORKING_CASH_P, LEASE_WORKING_CASH_PRESET.DOWN_PAYMENT_WITH_DRIVE_OFF, __('Down Payment + Inception Fee')), _defineProperty(_LEASE_WORKING_CASH_P, LEASE_WORKING_CASH_PRESET.DOWN_PAYMENT_WITH_MAX_DRIVE_OFF, __('Down Payment + Max. Inception Fee')), _defineProperty(_LEASE_WORKING_CASH_P, LEASE_WORKING_CASH_PRESET.DOWN_PAYMENT_WITH_MIN_DRIVE_OFF, __('Down Payment + Min. Inception Fee')), _LEASE_WORKING_CASH_P);
export var VEHICLE_TITLE_TYPES = [{
  label: 'Clean',
  value: 'CLEAN'
}, {
  label: 'Clear',
  value: 'CLEAR'
}, {
  label: 'Salvage',
  value: 'SALVAGE'
}, {
  label: 'Rebuilt',
  value: 'REBUILT'
}, {
  label: 'Unavailable',
  value: 'UNAVAILABLE'
}];
export var DEPOSIT_LABELS = {
  REVOKE_DEAL_CONFIRMATION: __('Revoke Deal Confirmation'),
  YES: __('Yes'),
  CONFIRM_WITHOUT_PAYMENT: __('Confirm without Payment'),
  REVOKE_DEAL: __('Revoke Deal'),
  CONFIRM_DEAL: __('Confirm Deal'),
  COLLECT_DEPOSIT: __('Collect Deposit to confirm the deal'),
  NO: __('No')
};